(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.$_isPad = $_isPad;
  function $_isPad() {
    var ans = false;
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    var height = window.innerHeight > 0 ? window.innerHeight : screen.height;
    var longSide = Math.max(width, height);
    var shortSide = Math.min(width, height);
    // 如果设备长的一边大于900px，短的一边小于850px
    // 公司pad的innerWidth/height列表，以浏览器内打开页面获取innerWidth/innerHeight:
    // Pad2：竖屏736*1048，横屏1120*640
    // Pad1：竖屏640*952，横屏1024*568
    if (longSide > 950 && shortSide < 850) {
      ans = true;
    }
    return ans;
  }
});